import { useEffect } from "react";
import Moment from 'react-moment';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { Card, CardBody, Table } from "reactstrap";

import { getSupportCases } from "services/case.service";
import { setGetMethod } from "reducers/dto.slice";

import { DEMO_EMAIL } from "appConstants";
import DataFilters from "components/shared/DataFilters";
import Paging from "components/shared/Paging";
import TableEmptyState from "components/shared/TableEmptyState";
import { setDemoCases } from "../reducers/case.slice";


const SupportCases = () => {
    const customer = useAppSelector(x => x.customers.selectedCustomer);
    const casesDto = useAppSelector(x => x.cases.casesDto);
    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);

    const cases = casesDto.items;
    const casesLoading = useAppSelector(x => x.cases.loading);
    const casesError = useAppSelector(x => x.cases.error);

    const dispatch = useAppDispatch();
    
    useEffect(() => {
        if (customer?.email === DEMO_EMAIL) {
            dispatch(setDemoCases());
        } else {

            dispatch(setGetMethod(getSupportCases));
            dispatch(getSupportCases(searchDto));
        }
    },
        [customer, dispatch, searchDto]);

    return (
        <Card className="shadow">
            <DataFilters />
            <CardBody>
                <Table bordered striped responsive className="bcd-data-table">
                    <thead>
                        <tr>
                            <th>
                                Incident Date
                            </th>
                            <th>
                                Case
                            </th>
                            <th>
                                Title
                            </th>
                            <th className="text-nowrap">
                                Serial Numbers
                            </th>
                            <th>
                                Assigned To
                            </th>
                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {cases.length > 0 ?
                            cases.map(o => {
                                return (<tr key={o.caseId}>
                                    <td width="10%">
                                        <Moment format="MM/DD/YYYY">
                                            {o.incidentDate}
                                        </Moment>
                                    </td>
                                    <td width="10%">{o.caseNumber}</td>
                                    <td>{o.title}</td>
                                    <td>{o.serialNumber}</td>
                                    <td width="10%">{o.assignedTo}</td>
                                    <td width="15%">{o.status}</td>
                                </tr>);
                            })
                            :
                            <TableEmptyState colSpan={6} isLoading={casesLoading} error={casesError} entityName="Support Cases" />
                        }
                    </tbody>
                </Table>
                <Paging />
            </CardBody>
        </Card>

    );
}

export default SupportCases;